import React from "react";
import { Box, Button, Portal, Text, UnstyledButton } from "@mantine/core";
import styles from "./MobileReportCanvas.module.css";

export interface MobileUnsavedBarProps {
  dirty: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

/**
 * Floating "● Unsaved changes · Discard · Save view" bar pinned to the
 * bottom of the screen (clear of the home indicator) while the view has
 * unsaved changes — the phone's version of the desktop header actions. It
 * sits under sheets and dialogs; the navigation guard still asks before
 * leaving.
 */
export default function MobileUnsavedBar({
  dirty,
  saving,
  onSave,
  onDiscard,
}: MobileUnsavedBarProps) {
  if (!dirty) return null;
  return (
    <Portal>
      <Box
        className={styles.unsavedBar}
        role="region"
        aria-label="Unsaved changes"
      >
        <Box component="span" className={styles.unsavedDot} aria-hidden />
        <Text component="span" className={styles.unsavedText}>
          Unsaved changes
        </Text>
        <UnstyledButton
          type="button"
          className={styles.discard}
          onClick={onDiscard}
          disabled={saving}
        >
          Discard
        </UnstyledButton>
        <Button
          color="teal"
          size="sm"
          onClick={onSave}
          loading={saving}
          title="Save as this report's default view"
        >
          Save view
        </Button>
      </Box>
    </Portal>
  );
}
